import { connect } from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { inject, observer } from 'mobx-react';
import { StringInput } from 'modules/core/components/forms';
import { FormModal } from 'modules/core/containers';

import { useEffect, ComponentProps } from 'react';
import type { FormikProps } from 'formik';
import { ClientProfile } from 'modules/clients/api/clientApi';
import * as actions from './store/actions';
import {
  clientActions,
  ClientStore,
} from './store/clientStore';
import RefValueSelector from '../core/components/selectors/RefValueSelector';
import { BonusHistoryInterface } from './api/clientApi';
import { bonusEditValidationSchema } from './validation';

interface BonusEditProps {
  clientId: string,
  onClose?: (...args: unknown[]) => unknown,
  onSubmit?: (...args: unknown[]) => unknown,
  clientStore?: ClientStore,
  getClient?: Function,
  clientProfile?: ClientProfile,
}

type TForm = ComponentProps<typeof FormModal> & Pick<FormikProps<any>, 'resetForm' | 'setSubmitting'>

const BonusEdit = (props: BonusEditProps) => {
  const {
    clientId,
    onClose,
    clientStore,
    getClient,
    clientProfile,
    onSubmit,
  } = props;

  const { currentBonusHistory } = clientStore;

  const loadClient = async () => {
    await getClient(clientId);
  };

  useEffect(() => {
    if (clientId && ((!clientId) || (clientProfile?.id !== clientId))) {
      loadClient();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientId]);

  const handleSubmit = async (values: BonusHistoryInterface, form: TForm) => {
    try {
      await clientActions.createClientBonus({
        clientId,
        // если начисление - то пишем в базу положительную сумму, списание - отрицательную
        bonus: values.operationTypeRefValueId === 345 ? values.bonus : -values.bonus,
        comment: values.comment,
        operationTypeRefValueId: values.operationTypeRefValueId,
      });

      form.resetForm();
      if (typeof onSubmit === 'function') {
        onSubmit();
      }
    } finally {
      form.setSubmitting(false);
    }
  };

  return (
    // @ts-ignore
    <FormModal
      show={ true }
      header='Корректировка бонусов'
      initialValues={ { ...currentBonusHistory, maxBonus: clientProfile.bonus ?? 0 } }
      validationSchema={ bonusEditValidationSchema }
      onClose={ onClose }
      onCancel={ onClose }
      onSubmit={ handleSubmit }
    >
      <Row>
        <Col lg={ 12 }>
              Клиент:
          <b>{ ` ${ clientProfile.lastName } ${ clientProfile.firstName }, ${ clientProfile.phoneNumber }  ` }</b>
          Бонусы:
          <b>{ ` ${ clientProfile.bonus ?? 0 }` }</b>
        </Col>
        <Col md={ 6 }>
          <StringInput
            name='bonus'
            label='Сумма'
            placeholder='Сумма'
            type='number'
          />
        </Col>
        <Col md={ 6 }>
          <RefValueSelector
            name='operationTypeRefValueId'
            refId={ 74 }
            label='Тип'
            placeholder='Тип'
          />
        </Col>
        <Col md={ 12 }>
          <StringInput
            name='comment'
            as='textarea'
            placeholder='Комментарий'
            label='Комментарий'
          />
        </Col>
      </Row>
    </FormModal>
  );
};

const mapStateToProps = (state) => {
  return {
    clientProfile: state.clients?.item,
  };
};

const mapDispatchToProps = {
  getClient: actions.getClientInfo,
};

export default connect(mapStateToProps, mapDispatchToProps)(inject('clientStore')(observer(BonusEdit)));
